module.exports = __webpack_public_path__ + "assets/star-off-f90690.svg";